export default {
  title: '猎头供应商管理',
  menu: '猎头供应商管理',
  agencyAdd: '添加猎头',
  agencyEdit: '编辑猎头',
  label: {
    name: '姓名',
    email: '邮箱地址',
    notes: '猎头公司（备注）',
    status: '状态'
  },
  placeholder: {

  },
  btn: {
    cancel: '取消',
    confirm: '保存',
    addAgency: '添加猎头'
  },
  message: {
  }
}
